<template>
  <span>{{ dateValue }}</span>
</template>

<script>
  import methods from '../../utils/methods';

  export default {
    name: 'DateCell',

    props: ['date'],

    computed: {
      dateValue: function () {
        return this.date ? methods.getDateFromUtc(this.date) : '--.--';
      },
    },
  };
</script>
